var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1026 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.83,1022.27C230.08,1022.27,0,792.19,0,509.5c0-115.14,37.63-224.13,108.86-315.26,32.64-41.73,92.99-49.09,134.72-16.51,41.79,32.64,49.15,92.99,16.51,134.72-44.48,57.02-68.03,125.12-68.03,196.99,0,176.9,143.94,320.77,320.83,320.77s320.77-143.87,320.77-320.77c0-71.94-23.55-140.03-68.03-196.99-32.7-41.79-25.28-102.14,16.51-134.72,41.73-32.64,102.08-25.28,134.72,16.51,71.17,91.07,108.8,200.06,108.8,315.26-.06,282.69-230.08,512.77-512.83,512.77h0ZM514.18,541.31h-2.69c-52.03,0-94.66-42.56-94.66-94.66V97.34c0-52.1,42.62-94.66,94.66-94.66h2.69c52.1,0,94.66,42.62,94.66,94.66v349.31c0,52.1-42.62,94.66-94.66,94.66h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogout);
export default __webpack_public_path__ + "static/media/menu-logout.c9cb3715a52676f851af8c860a4fa5cd.svg";
export { ForwardRef as ReactComponent };